import moment from 'moment';

export default {
    computed: {
        moment() {
            return moment;
        }
    },
    methods: {
        isExpired(date) {
            return date && moment(date).isBefore(moment());
        },
        isExpiring(date) {
            return date && moment(date).isBefore(moment().add(14, 'days')) && !this.isExpired(date);
        },
        getStatusLabel(date) {
            if (this.isExpired(date)) return 'Expired';
            if (this.isExpiring(date)) return 'Expiring Soon';
            return '';
        },
        getStatusColor(date) {
            if (this.isExpired(date)) return 'error';
            if (this.isExpiring(date)) return 'warning';
            return '';
        }
    }
};
